module.exports = __webpack_public_path__ + "img/metal@2x.f4e87bf.webp";